import React from 'react';
import { Link } from 'react-router-dom';
import ProductsHero from '../components/ProductsHero/ProductsHero';
import ProductModuleContent from '../components/ProductModuleContent/ProductModuleContent';
import './Products.css';

const SIX_BOXES = [
  {
    title: 'Clear ownership',
    description: 'Create projects with owners, teams, and responsibilities so everyone knows who is delivering what.',
  },
  {
    title: 'Timelines that hold',
    description: 'Set start dates, deadlines, and priorities so milestones stay visible from kickoff to close.',
  },
  {
    title: 'Progress you can see',
    description: 'Track status, delays, and completed work across the project without chasing updates in chat.',
  },
  {
    title: 'Stakeholder updates',
    description: 'Share progress with branches, departments, and stakeholders from one project record.',
  },
  {
    title: 'Team collaboration',
    description: 'Bring tasks, comments, and files into the project so work stays connected instead of scattered.',
  },
  {
    title: 'Built for growing teams',
    description: 'Run small internal jobs or larger multi-department projects on the same flowdo workspace.',
  },
];

const FEATURES = [
  'Ability to create small, medium or large size project',
  'Notifications in collaboration with Tasks',
  'Monitor all project status in one view',
  'Communicate and share in one platform',
  'Realtime updates of the status',
  'Team availability and progress tracking',
];

const ProductsProjects = () => (
  <div className="products-page">
    <ProductsHero title="Projects" bannerSection="Products > Projects">
      <p className="text-muted">
        Whether you are organizing a small get together, large event, managing a large IT project, or involved
        in a construction project, flowdo Projects will help you in managing them by collaborating with your
        team members. Track deadlines, get notified on delays, track team progress, and create individual sub
        tasks.
      </p>
      <p className="text-muted">
        flowdo Projects works with flowdo Tasks to provide seamless management of various tasks under a Project.
        Set reminders and notify team to avoid any delays in completing your Project.
      </p>
      <p className="text-muted">
        Generate reports and team utilization details in real time allowing you to plan for future Projects.
        Upload all related documents and communicate with team members, allowing you to view records in the
        future.
      </p>
    </ProductsHero>
    <ProductModuleContent
      sixBoxes={SIX_BOXES}
      features={FEATURES}
    />
    <section className="products-bundle-note">
      <div className="container">
        <h2 className="products-bundle-note__title">Pricing</h2>
        <p className="products-bundle-note__copy">
        To access Projects, please do Subscribe for the appropriate subscription model from TASKS. 
        </p>
        <Link to="/pricing" className="products-bundle-note__btn">
          View pricing
        </Link>
      </div>
    </section>
  </div>
);

export default ProductsProjects;
